export const providerPrice = products =>
  products?.map(({ total, extraService }) => total || extraService?.price || 0)?.reduce((a, b) => a + b, 0)

export const getTotalOfValidProducts = products =>
  products?.reduce((acc, { amount }) => (amount > 0 ? acc + 1 : acc), 0)
